import {
  ICategoryCityListingResponse,
  ICategoryListingNormalizedData,
  ICategoryListingResponse,
  ICategoryListingResponseAction,
  ICategoryPayload,
  ICategoryProductsResponse, IImageObject,
} from "../interfaces/Index";

interface ICoreCatgory {
  key: string;
  value: string;
}

export const normalizeCategoryReqPayload = (
  payload: ICategoryPayload,
  isEdit: boolean = false
) => {
  let reqPayload: any = {};
  if (payload.categoryType === "sub_category") {
    reqPayload.parentCategoryId = payload.coreCategory;
  }
  reqPayload.name = payload.categoryTitle;
  reqPayload.description = payload.categoryDescription;
  reqPayload.enabled = payload.status ? 1 : 0;
  reqPayload.handle = payload.categoryHandle || "";
  reqPayload.categoryFlag = payload.categoryFeature;
  if (isEdit) {
    reqPayload.id = payload.id;
    reqPayload.imageId = payload.categoryImageId;
    if (!(payload.categoryImage as any).multiPartData) {
      reqPayload.imageUrl = (payload.categoryImage as any).base64StringUrl;
    }
  } else {
    reqPayload.imageId = "";
  }

  return reqPayload;
};

export const normalizeCategoryImage = (payload: ICategoryPayload) => {
  let formData: any = new FormData();
  const imageData =
    payload.categoryImage && (payload.categoryImage! as any).multiPartData
      ? (payload.categoryImage! as any).multiPartData
      : "";

  formData.append("image", imageData);
  return formData;
};

export const normalizeCategoryImageData = (image: IImageObject) => {
  let formData: any = new FormData();
  const imageData = image && image.multiPartData ? image.multiPartData : "";
  formData.append("image", imageData);
  return formData;
};

export const normalizeCoreCategory = (payload: Array<ICoreCatgory> = []) => {
  return payload.map((coreCategory) => {
    return {
      id: coreCategory.key,
      value: coreCategory.value,
      title: coreCategory.value,
      key: coreCategory.key,
    };
  });
};

export const normalizeProductDetailPageCategoryListing = (
  res: Array<Array<ICategoryListingResponse>>,
  pagination: number | boolean,
  isPaginatedRes: boolean
) => {
  let payload: any = {
    pagination: res.length === 50 ? pagination : false,
    isPaginatedRes,
  };
  let categoriesData: Array<ICategoryListingNormalizedData> = [];

  res.forEach((category: Array<ICategoryListingResponse>) => {
    let catParentId: any;
    if (category.length > 1) {
      category.forEach((items: ICategoryListingResponse) => {
        if (items.categoryType === "parent") catParentId = items.id;
        const listItem: any = {
          id: items.id,
          categoryTitle: items.title,
          categoryImage: items.imageUrl ? items.imageUrl : "",
          categoryDescription: items.description,
          isEnabled: items.enabled,
          categoryType:
            items.categoryType === "parent" ? "core" : "sub_category",
          parentId: items.categoryType === "child" ? catParentId : null,
          categoryImageId: items.imageId || "",
          categoryHandle: items.handle || "",
        };
        categoriesData.push(listItem);
      });
    } else {
      category.forEach((items: ICategoryListingResponse) => {
        const listItem: any = {
          id: items.id,
          categoryTitle: items.title,
          categoryImage: items.imageUrl ? `${items.imageUrl}` : "",
          categoryDescription: items.description,
          isEnabled: items.enabled,
          categoryType:
            items.categoryType === "parent" ? "core" : "sub_category",
          parentId: null,
          categoryImageId: items.imageId || "",
          categoryHandle: items.handle || "",
        };
        categoriesData.push(listItem);
      });
    }
  });

  payload.categoriesData = categoriesData;
  return payload;
};

const mapCategoryResponse = (parentCategory: ICategoryCityListingResponse | null,
                             category: ICategoryCityListingResponse): ICategoryListingNormalizedData => {
  return {
    id: category.id,
    categoryTitle: category.title,
    categoryHandle: category.handle,
    categoryImageId: category.imageId,
    categoryImage: category.imageUrl,
    categoryFlag: category.categoryFlag,
    isEnabled: category.isEnabled,
    categoryType: parentCategory ? "sub_category" : "core",
    parentId: parentCategory ? parentCategory.id : null
  };
};

const mapCategoriesResponse = (categories: Array<ICategoryCityListingResponse>) => {
  return categories.map((parentCategory: ICategoryCityListingResponse) => {
    // mapping Parent category
    let flatCategoriesList: ICategoryListingNormalizedData[] = [mapCategoryResponse(null, parentCategory)];

    // mapping Child categories
    const mappedChildren = parentCategory.children?.map((childCategory) => mapCategoryResponse(parentCategory, childCategory))
    return flatCategoriesList.concat(mappedChildren ? mappedChildren : []);
  });
};

export const normalizeCategoryCityListingResponse = (
    categories: Array<ICategoryCityListingResponse>,
    pagination: number,
    isPaginatedRes: boolean
): ICategoryListingResponseAction => {
  return {
    pagination: categories.length === 50 ? pagination : null,
    isPaginatedRes,
    categoriesData: mapCategoriesResponse(categories)
  };
};

export const normalizeCategoryListing = (
  res: Array<Array<ICategoryListingResponse>>,
  pagination: number | boolean,
  isPaginatedRes: boolean
) => {
  let payload: any = {
    pagination: res.length === 50 ? pagination : false,
    isPaginatedRes,
  };

  res = res.map((items: any) => {
    let catParentId: any;
    return items.map((item: any) => {
      if (item.categoryType === "parent") {
        catParentId = item.id;
      }

      return {
        id: item.id,
        categoryTitle: item.title,
        categoryImage: item.imageUrl ? item.imageUrl : "",
        categoryDescription: item.description,
        isEnabled: item.enabled,
        categoryType: item.categoryType === "parent" ? "core" : "sub_category",
        categoryFeature: item.categoryFlag || "DEFAULT",
        parentId: item.categoryType === "child" ? catParentId : null,
        categoryImageId: item.imageId || "",
        categoryHandle: item.handle || "",
      };
    });
  });

  payload.categoriesData = res;
  return payload;
};

export const normalizeSelectedPayloadForEditFlow = (
  category: ICategoryListingNormalizedData
) => {
  return {
    ...category,
    status: category.isEnabled ? "ACTIVE" : "INACTIVE",
    coreCategory: category.parentId,
    categoryImage: {
      base64StringUrl: category.categoryImage,
    },
  };
};

export const normalizeProductByDisplayOrderResponse = (
  data: Array<ICategoryProductsResponse>
) => {
  return data.map((item: ICategoryProductsResponse) => {
    return {
      id: item.id,
      title: item.title,
      imageUrl: item.imageUrl,
    };
  });
};

export const normalizeCategoryProductReqPayload = (
  categoryProductOrder: Array<ICategoryProductsResponse>
) => {
  const reOrderPayload: any = {
    products: {},
  };
  let obj = {
    order: -1,
  };

  categoryProductOrder.forEach(
    (item: ICategoryProductsResponse, index: number) => {
      obj.order = index;
      reOrderPayload.products[item.id] = { ...obj };
    }
  );

  return reOrderPayload;
};
